import React, { useState, useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import '../styles/ContactForm.css'; // Du kan återanvända samma stilfil!

const API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:5000/api/intresseanmalan'
    : 'https://umrah-backend.onrender.com/api/intresseanmalan';

const InterestForm = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [feedback, setFeedback] = useState({ type: '', message: '' });
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const recaptchaRef = useRef();

  useEffect(() => {
    document.title = 'Intresseanmälan – Umrah Bröderna';
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!recaptchaToken) {
      setFeedback({ type: 'error', message: 'Vänligen bocka i reCAPTCHA.' });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          token: recaptchaToken,
        }),
      });

      if (response.ok) {
        setFeedback({ type: 'success', message: 'Din intresseanmälan skickades!' });
        setFormData({ name: '', email: '', message: '' });
        recaptchaRef.current.reset();
        setRecaptchaToken(null);
      } else {
        setFeedback({ type: 'error', message: 'Något gick fel. Försök igen.' });
      }
    } catch (error) {
      console.error('Error:', error);
      setFeedback({ type: 'error', message: 'Serverfel, försök senare.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container" style={{ backgroundColor: '#588b85' }}>
      <form onSubmit={handleSubmit} className="contact-form">
        <h1>Intresseanmälan</h1>

        <label><strong>Namn</strong></label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />

        <label><strong>E-post</strong></label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />

        <label><strong>Meddelande</strong></label>
        <textarea name="message" rows="5" value={formData.message} onChange={handleChange} required />

        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey="6Lctpf4qAAAAAE_p4tR5efpFV25a1UHxsJjsdSmF"
          onChange={(token) => setRecaptchaToken(token)}
        />

        <button type="submit" disabled={isSubmitting} className="submit-button">
          {isSubmitting ? 'Skickar...' : 'Skicka Meddelande'}
        </button>

        {feedback.message && (
          <div className={`mt-6 p-4 rounded text-white text-center ${feedback.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}>
            {feedback.message}
          </div>
        )}
      </form>
    </div>
  );
};

export default InterestForm;
